import type { SearchFilters } from "./types";

export const emptyFilters: SearchFilters = {
  collections: [],
  documentTypes: [],
  years: [],
  tags: [],
};

export function toggleValue<T>(values: T[], value: T): T[] {
  return values.includes(value)
    ? values.filter((item) => item !== value)
    : [...values, value];
}

export function hasActiveFilters(filters: SearchFilters): boolean {
  return (
    filters.collections.length > 0 ||
    filters.documentTypes.length > 0 ||
    filters.years.length > 0 ||
    filters.tags.length > 0
  );
}

export function activeFilterCount(filters: SearchFilters): number {
  return (
    filters.collections.length +
    filters.documentTypes.length +
    filters.years.length +
    filters.tags.length
  );
}
